import {yupResolver} from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import UndoIcon from '@mui/icons-material/Undo';
import {Button, Grid} from '@mui/material';
import React, {useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {i18n} from 'src/i18n';
import yupFormSchemas from 'src/modules/shared/yup/yupFormSchemas';
import FuncionAutocompleteFormItem from 'src/view/funcion/autocomplete/FuncionAutocompleteFormItem';
import InputFormItem from 'src/view/shared/form/items/InputFormItem';
import FormWrapper, {FormButtons} from 'src/view/shared/styles/FormWrapper';
import UserAutocompleteFormItem from 'src/view/user/autocomplete/UserAutocompleteFormItem';
import * as yup from 'yup';

const schema = yup.object().shape({
  meta: yupFormSchemas.relationToOne(i18n('entities.asignadorFuncion.fields.meta'), {}),
  nombreFuncion: yupFormSchemas.string(i18n('entities.asignadorFuncion.fields.nombreFuncion'), {
    required: true,
  }),
  empleados: yupFormSchemas.relationToMany(i18n('entities.asignadorFuncion.fields.empleados'), {
    required: true,
  }),
  funcion: yupFormSchemas.relationToOne(i18n('entities.asignadorFuncion.fields.funcion'), {
    required: true,
  }),
});

function AsignadorFuncionForm(props) {
  const [initialValues] = useState(() => {
    const record = props.record || {};

    return {
      meta: record.meta,
      nombreFuncion: record.nombreFuncion,
      empleados: record.empleados || [],
      funcion: record.funcion,
    };
  });

  const form = useForm({
    resolver: yupResolver(schema),
    mode: 'all',
    defaultValues: initialValues as any,
  });

  const onSubmit = (values) => {
    props.onSubmit(props.record?.id, values);
  };

  const onReset = () => {
    Object.keys(initialValues).forEach((key) => {
      form.setValue(key, initialValues[key]);
    });
  };

  const {saveLoading, modal} = props;

  return (
    <FormWrapper>
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <Grid spacing={2} container>
            <Grid item lg={7} md={8} sm={12} xs={12}>
              <InputFormItem
                name="nombreFuncion"
                label={i18n('entities.asignadorFuncion.fields.nombreFuncion')}
                required={true}
              />
            </Grid>
            {/*
              <Grid item lg={7} md={8} sm={12} xs={12}>
                <FuncionAutocompleteFormItem
                  name="meta"
                  label={i18n('entities.asignadorFuncion.fields.meta')}
                  required={false}
                  showCreate={!props.modal}
                />
              </Grid>
            */}
            <Grid item lg={7} md={8} sm={12} xs={12}>
              <UserAutocompleteFormItem
                name="empleados"
                label={i18n('entities.asignadorFuncion.fields.empleados')}
                required={true}
                showCreate={!props.modal}
                mode="multiple"
              />
            </Grid>
            <Grid item lg={7} md={8} sm={12} xs={12}>
              <FuncionAutocompleteFormItem
                name="funcion"
                label={i18n('entities.asignadorFuncion.fields.funcion')}
                required={true}
                showCreate={!props.modal}
              />
            </Grid>
          </Grid>
          <FormButtons
            style={{
              flexDirection: modal ? 'row-reverse' : undefined,
            }}>
            <Button
              variant="contained"
              color="primary"
              disabled={saveLoading}
              type="button"
              onClick={form.handleSubmit(onSubmit)}
              startIcon={<SaveIcon />}
              size="small">
              {i18n('common.save')}
            </Button>

            <Button disabled={saveLoading} onClick={onReset} type="button" startIcon={<UndoIcon />} size="small">
              {i18n('common.reset')}
            </Button>

            {props.onCancel ? (
              <Button
                disabled={saveLoading}
                onClick={() => props.onCancel()}
                type="button"
                startIcon={<CloseIcon />}
                size="small">
                {i18n('common.cancel')}
              </Button>
            ) : null}
          </FormButtons>
        </form>
      </FormProvider>
    </FormWrapper>
  );
}

export default AsignadorFuncionForm;
